/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Inspector_HintInputs */

const cs_pipelines_inspector_hint = /** @type {(inputs: Pipelines_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte fázi na plátně, nebo přidejte novou.`)
};

const en_pipelines_inspector_hint = /** @type {(inputs: Pipelines_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a stage on the canvas, or add a new one.`)
};

/**
* | output |
* | --- |
* | "Select a stage on the canvas, or add a new one." |
*
* @param {Pipelines_Inspector_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_inspector_hint = /** @type {((inputs?: Pipelines_Inspector_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Inspector_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_inspector_hint(inputs)
	return cs_pipelines_inspector_hint(inputs)
});